import { createPopper, popperGenerator, detectOverflow } from "./createPopper.js";
// eslint-disable-next-line import/no-unused-modules
export { createPopper, popperGenerator, detectOverflow };


//////////////////
// WEBPACK FOOTER
// ../~/@popperjs/core/lib/popper-base.js
// module id = 1758
// module chunks = 121